import { put, takeLatest } from 'redux-saga/effects';

import { requestClientList,requestTdsList, requestClientFilterList, requestCreateClient,requestUpdateClient,requestDeleteClient,requestAllDeleteClient,uploadExcelData, requestClientAgreementDetails} from '../../../services/client';
import { uploadClientRequest, uploadClientSuccess, uploadClientFaliure, deleteClientRequest,deleteAllClientRequest,deleteAllClientSuccess,deleteAllClientFaliure,
  deleteClientSuccess,
  deleteClientFaliure,
  fetchClientListFailure,  
  fetchTdsListSuccess,
  fetchTdsListRequest,
  fetchTdsListFailure,
  fetchClientListRequest, 
  fetchClientListSuccess, 
  fetchClientFilterListFailure, 
  fetchClientFilterListRequest, 
  fetchClientFilterListSuccess,
  createClientRequest,
  createClientSuccess,
  createClientFailure,
  updateClientRequest,
  updateClientSuccess,
  updateClientFaliure,
  fetchClientAgreementListRequest,
  fetchClientAgreementListSuccess,
  fetchClientAgreementListFailure, } from '../../reducers/client';

export function* watchClientSaga() {
  yield takeLatest(fetchClientListRequest, fetchClientList);
  yield takeLatest(fetchTdsListRequest, fetchTdsList);
  yield takeLatest(fetchClientFilterListRequest, fetchClientFilterList);
  yield takeLatest(createClientRequest ,createClient);
  yield takeLatest(updateClientRequest ,updateClient);
  yield takeLatest(deleteClientRequest ,deleteClient);
  yield takeLatest(uploadClientRequest ,uploadClient);
  yield takeLatest(deleteAllClientRequest ,deleteAllClient);
  yield takeLatest(fetchClientAgreementListRequest, fetchClientAgreementList);
}

/**
 *
 * @param {*} param0
 */
function* fetchClientList({ payload }) {
  try {
    const response = yield requestClientList(payload);
    yield put(fetchClientListSuccess(response));
  } catch (error) {
    yield put(fetchClientListFailure("Failed to get list of client"));
  }
}
function* fetchTdsList({ payload }) {
  try {
    const response = yield requestTdsList(payload);
    yield put(fetchTdsListSuccess(response));
  } catch (error) {
    yield put(fetchTdsListFailure("Failed to get list of client"));
  }
}
function* fetchClientFilterList({ payload }) {
  try {
    const response = yield requestClientFilterList(payload);
    yield put(fetchClientFilterListSuccess(response));
  } catch (error) {
    yield put(fetchClientFilterListFailure("Failed to get list of client"));
  }
}
function* createClient({ payload }) {
  
  try {
    //service add
    const response = yield requestCreateClient(payload);
    yield put(createClientSuccess(response.data));
  } catch (error) {
    yield put(  createClientFailure
      ('Failed to create Client'));
  }
}
function* updateClient({ payload }) {
  try {
    const response =yield requestUpdateClient(payload);
    yield put(updateClientSuccess(response.data));
  } catch (error) {
    yield put(updateClientFaliure('Failed to get update Client'));
  }
}

function* deleteClient({ payload }) {
  try {
    const response =yield requestDeleteClient(payload);
    yield put(deleteClientSuccess(response.data));
  } catch (error) {
    yield put(deleteClientFaliure('Failed to get update Client'));
  }
}
function* uploadClient({ payload }) {
  try {
    const response =yield uploadExcelData(payload);
    yield put(uploadClientSuccess(response.data));
  } catch (error) {
    yield put(uploadClientFaliure('Failed to get update Client'));
  }
}
function* deleteAllClient({ payload }) {
  try {
    const response =yield requestAllDeleteClient(payload);
    yield put(deleteAllClientSuccess(response.data));
  } catch (error) {
    yield put(deleteAllClientFaliure('Failed to get update Client'));
  }
}
function* fetchClientAgreementList({ payload }) {
  try {
    const response = yield requestClientAgreementDetails(payload);
    yield put(fetchClientAgreementListSuccess(response));
  } catch (error) {
    yield put(fetchClientAgreementListFailure("Failed to get list of client"));
  }
}
